import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "../lib/auth";
import MfaSetupPanel from "./MfaSetupPanel";
import EnvironmentBanner from "./EnvironmentBanner";

export default function RequireAuth({ children }) {
  const { isAuthed, authState, authError, restoreSession, session } = useAuth();
  const location = useLocation();
  if (authState === "loading") {
    return <div className="min-h-screen grid place-items-center bg-slate-50 text-[#082B4D]"><div className="flex items-center gap-2 text-sm"><Loader2 className="w-5 h-5 animate-spin" /> Restoring secure session…</div></div>;
  }
  if (authState === "error") {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
        <div className="max-w-md rounded-xl border border-amber-200 bg-white p-5 text-center shadow-sm">
          <ShieldAlert className="w-8 h-8 text-amber-600 mx-auto" />
          <h1 className="font-heading font-bold text-[#082B4D] mt-3">Session verification unavailable</h1>
          <p className="text-sm text-slate-600 mt-2">{authError}</p>
          <button type="button" onClick={restoreSession} className="mt-4 px-4 py-2 rounded-lg bg-[#082B4D] text-white text-sm">Retry</button>
        </div>
      </div>
    );
  }
  if (!isAuthed) return <Navigate to="/login" state={{ from: location.pathname, sessionExpired: Boolean(authError) }} replace />;
  if (session?.user?.mfa?.enrollmentRequired) return <div className="min-h-screen bg-slate-50"><EnvironmentBanner /><div className="max-w-2xl mx-auto p-6"><MfaSetupPanel required /></div></div>;
  return children;
}
